import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ShoppingBagIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M11.901 2c3.173 0 5.13 1.75 5.819 5H19a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h1.207c.602-3.246 2.517-5 5.694-5zM19 9h-1.026c.018.324.027.658.026 1.002a1 1 0 01-2-.004c0-.35-.008-.682-.026-.999h-7.97c-.007.308-.006.631.005.97a1 1 0 11-2 .062A17.533 17.533 0 016.008 9H5v10h14V9zm-7.099-5c-1.982 0-3.193.933-3.669 3h7.448c-.545-2.063-1.792-3-3.779-3z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ShoppingBagIcon.isCarinaIcon = true;
export default ShoppingBagIcon;
